import { Alert } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { getLocalExpirationTime } from '@app/utils/time';
const ClosingTime = ({ expiresAt }) => {
    const { t } = useTranslation();
    const time = getLocalExpirationTime(expiresAt);
    return (<Alert title={t('financing.closing_time.title')} variant="warning">
            <div className="body-m">{t('financing.closing_time.message', { time })}</div>
        </Alert>);
};
export default ClosingTime;
